import * as React from "react";
import {RouteComponentProps} from "react-router-dom";

// components
import {Header} from "../sportVariance/header";
import GridCell from "../gridcell";

// services & helpers
import {ProductService} from "../../../api/services/productSearchService";
import {capitalizeFirstLetter} from "../../../helpers/textValidationHelpers";
import {endFullLoadingSpinner, startFullLoadingSpinner} from "../../../actions/loadingSpinnerActions";
import {GenderSportConfig} from "../sportVariance/config";
import {AkamaiAssetService} from "../../../api/services/ntsWebappService";

// types
type RouteProps = RouteComponentProps<{
    sport: string;
    gender: string;
}>

interface Banner {
    source: string;
    title: string;
    text: string;
}

interface PageProps {
    banner: Banner;
}

type Props = PageProps & RouteProps;

interface State {
    sport: string;
    gender: string;
    config: GenderSportConfig | null;
    items: [],
    error: string,
    isLoading: boolean
}

export class PromoLandingPage extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            sport: '',
            gender: '',
            config: null,
            items: [],
            error: '',
            isLoading: true
        }
    }

    async componentDidMount() {
        await this.fetchPromoPageConfig();
    }

    getPageConfig(gender:string = "", sport:string = "", config:any) {
        if (!config ||
            !config[gender] ||
            !config[gender][sport]) {
            return null;
        }
        return {
            ...config[gender][sport]
        };
    }

    async fetchPromoPageConfig() {
        const response = await AkamaiAssetService.getPromoPageConfig()
        if(response) {
            const sport = this.props.match.params.sport.toLowerCase();
            const gender = this.props.match.params.gender.toLowerCase();
            const pageConfig = this.getPageConfig(gender, sport, response);
            if(!pageConfig) {
                window.location.href = window.location.protocol + '//' + window.location.host + "/en/en_US/nts/";
            }
            this.fetchItems(sport, gender, pageConfig).catch(() => {
                this.setState({...this.state, error: 'Unable to retrieve items. Please try again.', items: [], isLoading: false });
                endFullLoadingSpinner();
            });
        }
    }

    async fetchItems(sport:string, gender:string, config:any) {
        const sportQueryParam = `sport_${capitalizeFirstLetter(sport.replace("%20", "_"))}`;
        const genderQueryParam = `gender_${capitalizeFirstLetter(gender.slice(0, -1))}`;

        startFullLoadingSpinner()

        const data = await ProductService.getPromoItems(sportQueryParam, genderQueryParam)
            .catch(() => {
                this.setState({...this.state, error: 'Unable to retrieve items. Please try again.', items: [], isLoading: false });
                endFullLoadingSpinner();
            });

        if (data && data.length > 0) {
            this.setState({...this.state, error: '', items: data, isLoading: false, config: config});
        } else {
            this.setState({...this.state, error: '', items: [], isLoading: false, config: config });
        }

        endFullLoadingSpinner();
    }

    render() {

        return (
            <div className="container nts-promo-landing-page">

                <div className="nts-header-container">
                    <div className="nts-header-nav">
                        {this.state.config &&
                            <Header
                                isSportVariance={true}
                                config={this.state.config}
                                category={''}
                            />
                        }
                    </div>
                </div>

                <div className="grid-results-container">
                    <div className="grid-cells-container">
                        {!this.state.isLoading && this.state.items.length > 0 && this.state.items.map((item, i) => (
                            <GridCell key={i} item={item} isLoggedIn={true} />
                        ))}
                        {!this.state.isLoading && !this.state.error && this.state.items.length === 0 &&
                            <div className="grid-message">
                                <h4>No results found</h4>
                                <p>There are currently no promo items available for this sport</p>
                            </div>
                        }
                        {!this.state.isLoading && this.state.error && <div className="grid-message error">{this.state.error}</div>}
                    </div>
                </div>

            </div>
        );
    }
}
